module.exports = __webpack_public_path__ + "images/img-3PtdP3G.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/13.png
// module id = 2337
// module chunks = 0